import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { ButtonSeeOtherComponent } from './components/button-see-other/button-see-other.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerModule } from '../spinner/spinner.module';

@NgModule({
  declarations: [ButtonComponent, ButtonSeeOtherComponent],
  imports: [CommonModule, SpinnerModule, TranslateModule],
  exports: [ButtonComponent, ButtonSeeOtherComponent],
})
export class ButtonModule {}
